"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.to-string.js");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _exportWarehouse = require("@/api/export-warehouse");
var _enum = require("@/utils/enum");
var _vuePropertyDecorator = require("vue-property-decorator");
var _ExportProductOrderForm = _interopRequireDefault(require("./ExportProductOrderForm.vue"));
var _moment = _interopRequireDefault(require("moment"));
var _ExportWarehousePrint = _interopRequireDefault(require("./ExportWarehousePrint.vue"));
var _ExportPrintInformationForm = _interopRequireDefault(require("./ExportPrintInformationForm.vue"));
var _ExportWarehousePrintPaymentRequest = _interopRequireDefault(require("./ExportWarehousePrintPaymentRequest.vue"));
var _SelectSingleDateModal = _interopRequireDefault(require("@/components/Shared/SelectSingleDateModal.vue"));
var OrderModal = /*#__PURE__*/function (_Vue) {
  function OrderModal() {
    var _this;
    (0, _classCallCheck2.default)(this, OrderModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, OrderModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {
      products: [],
      type: _enum.ExportWarehouseType.Export
    });
    (0, _defineProperty2.default)(_this, "status", "create");
    (0, _defineProperty2.default)(_this, "orderStatus", "");
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "orderProgress", {});
    (0, _defineProperty2.default)(_this, "ExportWarehouseType", _enum.ExportWarehouseType);
    return _this;
  }
  (0, _inherits2.default)(OrderModal, _Vue);
  return (0, _createClass2.default)(OrderModal, [{
    key: "handlePrint",
    value: function handlePrint() {
      this.$refs.SelectDateModal.handleCreate(this.form.date / 1000);
    }
  }, {
    key: "handleSelectDateOk",
    value: function handleSelectDateOk(date) {
      this.$refs.printExportWarehouse.handlePrint(date);
    }
  }, {
    key: "handlePrintPaymentRequest",
    value: function handlePrintPaymentRequest() {
      this.$refs.printExportWarehousePaymentRequest.handlePrint();
    }
  }, {
    key: "handleDelete",
    value: function () {
      var _handleDelete = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$confirm("Confirm delete order", "Warning", {
                cancelButtonText: "No",
                confirmButtonText: "Delete",
                type: "warning"
              });
            case 2:
              _context.prev = 2;
              this.loading = true;
              _context.next = 6;
              return _exportWarehouse.exportWarehouseApi.delete(this.form.id);
            case 6:
              this.$emit("submit:ok");
              this.visible = false;
              this.$notify.success({
                title: "Delete order",
                message: "Successfully"
              });
            case 9:
              _context.prev = 9;
              this.loading = false;
              return _context.finish(9);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2,, 9, 12]]);
      }));
      function handleDelete() {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }()
  }, {
    key: "createData",
    value: function () {
      var _createData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var _this2 = this;
        var form, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return this.$refs.product.$refs.form.validate();
            case 3:
              _context2.next = 8;
              break;
            case 5:
              _context2.prev = 5;
              _context2.t0 = _context2["catch"](0);
              return _context2.abrupt("return", this.$message.error("Fill correct all input"));
            case 8:
              if (this.form.products.length) {
                _context2.next = 10;
                break;
              }
              return _context2.abrupt("return", this.$message.error("Products least 1 item!"));
            case 10:
              form = (0, _objectSpread2.default)({}, this.form);
              delete form.products;
              data = {
                exportWarehouse: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, form), {}, {
                  date: form.date / 1000
                }),
                details: this.form.products.map(function (e) {
                  return {
                    quantity: e.exportQuantity,
                    productId: e.id
                  };
                }),
                staffId: this.form.staffId
              };
              this.loading = true;
              _exportWarehouse.exportWarehouseApi.create(data).then(function () {
                _this2.$notify.success({
                  title: "New export warehouse",
                  message: "Successfully"
                });
                _this2.$emit("submit:ok");
                _this2.visible = false;
              }).finally(function () {
                return _this2.loading = false;
              });
            case 15:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 5]]);
      }));
      function createData() {
        return _createData.apply(this, arguments);
      }
      return createData;
    }()
  }, {
    key: "updateData",
    value: function () {
      var _updateData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var form;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.prev = 1;
              _context3.next = 4;
              return this.$refs.product.$refs.form.validate();
            case 4:
              _context3.next = 9;
              break;
            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](1);
              return _context3.abrupt("return", this.$message.error("Fill correct all input"));
            case 9:
              if (this.form.products.length) {
                _context3.next = 11;
                break;
              }
              return _context3.abrupt("return", this.$message.error("Products least 1 item!"));
            case 11:
              this.loading = true;
              form = (0, _objectSpread2.default)({}, this.form);
              _context3.next = 15;
              return _exportWarehouse.exportWarehouseApi.update(this.form.id, {
                exportWarehouse: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, form), {}, {
                  date: form.date / 1000
                }),
                staffId: this.form.staffId
              });
            case 15:
              _context3.next = 17;
              return this.updateDetail();
            case 17:
              this.visible = false;
              this.$notify({
                title: "Update export warehouse",
                message: "Successfully",
                type: "success"
              });
              this.$emit("submit:ok");
            case 20:
              _context3.prev = 20;
              this.loading = false;
              return _context3.finish(20);
            case 23:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0,, 20, 23], [1, 6]]);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "updateDetail",
    value: function () {
      var _updateDetail = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        var i, e, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              i = 0;
            case 1:
              if (!(i < this.form.products.length)) {
                _context4.next = 14;
                break;
              }
              e = this.form.products[i];
              data = {
                quantity: e.exportQuantity,
                productId: e.id
              };
              if (e.detailId) {
                _context4.next = 9;
                break;
              }
              _context4.next = 7;
              return _exportWarehouse.exportWarehouseApi.addDetail(this.form.id, {
                detail: data
              });
            case 7:
              _context4.next = 11;
              break;
            case 9:
              _context4.next = 11;
              return _exportWarehouse.exportWarehouseApi.updateDetailQuantity(e.detailId, {
                quantity: e.exportQuantity
              });
            case 11:
              i++;
              _context4.next = 1;
              break;
            case 14:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function updateDetail() {
        return _updateDetail.apply(this, arguments);
      }
      return updateDetail;
    }()
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      this.visible = true;
      this.status = "create";
      this.form = {
        products: [],
        date: (0, _moment.default)().valueOf(),
        type: _enum.ExportWarehouseType.Export
      };
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(data) {
      console.log({
        dataNha: data
      });
      var printNote = data.printNote;
      if (!printNote) {
        if (data.type == _enum.ExportWarehouseType.Giveaway) {
          printNote = "";
        } else if (data.type == _enum.ExportWarehouseType.DepositOrder) {
          printNote = "Xuất kho ký gửi";
        } else {
          printNote = "Xuất kho bán hàng";
        }
      }
      var printCustomerName = data.printCustomerName;
      if (!printCustomerName) {
        if (data.type == _enum.ExportWarehouseType.Giveaway) {
          var _data$giveaway;
          printCustomerName = ((_data$giveaway = data.giveaway) === null || _data$giveaway === void 0 || (_data$giveaway = _data$giveaway.customer) === null || _data$giveaway === void 0 ? void 0 : _data$giveaway.name) || "";
        } else if (data.type == _enum.ExportWarehouseType.DepositOrder) {
          var _data$depositOrder;
          printCustomerName = ((_data$depositOrder = data.depositOrder) === null || _data$depositOrder === void 0 || (_data$depositOrder = _data$depositOrder.customer) === null || _data$depositOrder === void 0 ? void 0 : _data$depositOrder.name) || "";
        } else {
          var _data$order;
          printCustomerName = ((_data$order = data.order) === null || _data$order === void 0 || (_data$order = _data$order.customer) === null || _data$order === void 0 ? void 0 : _data$order.name) || "";
        }
      }
      var printCode = "";
      if (data.type == _enum.ExportWarehouseType.Giveaway) {
        var _data$giveaway2;
        printCode = ((_data$giveaway2 = data.giveaway) === null || _data$giveaway2 === void 0 ? void 0 : _data$giveaway2.code) || "";
      } else if (data.type == _enum.ExportWarehouseType.DepositOrder) {
        var _data$depositOrder2;
        printCode = ((_data$depositOrder2 = data.depositOrder) === null || _data$depositOrder2 === void 0 ? void 0 : _data$depositOrder2.code) || "";
      } else {
        var _data$order2;
        printCode = ((_data$order2 = data.order) === null || _data$order2 === void 0 ? void 0 : _data$order2.code) || "";
      }
      var printProof = data.printProof;
      if (!printProof) {
        if (data.type == _enum.ExportWarehouseType.Giveaway) {
          var _data$giveaway3;
          printProof = ((_data$giveaway3 = data.giveaway) === null || _data$giveaway3 === void 0 ? void 0 : _data$giveaway3.invoice) || "";
        } else if (data.type == _enum.ExportWarehouseType.DepositOrder) {
          var _data$depositOrder3;
          printProof = ((_data$depositOrder3 = data.depositOrder) === null || _data$depositOrder3 === void 0 ? void 0 : _data$depositOrder3.invoice) || "";
        } else {
          var _data$order3;
          printProof = ((_data$order3 = data.order) === null || _data$order3 === void 0 ? void 0 : _data$order3.invoice) || "";
        }
      }
      this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        products: data.exportWarehouseDetails.map(function (e) {
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, e), {}, {
            id: e.product.id,
            productGalleries: e.product.productGalleries,
            name: e.product.name,
            detailId: e.id,
            quantity: e.product.quantity,
            exportQuantity: e.quantity,
            remainQuantity: e.product.quantity
          });
        }),
        staffId: data.staff && data.staff.id,
        date: data.date * 1000,
        printProof: printProof,
        printCode: printCode,
        printNote: printNote,
        printCustomerName: printCustomerName
      });
      this.visible = true;
      this.status = "update";
      this.orderStatus = data.orderStatus;
      console.log("ExportWarehouseModal data:", data);
    }
  }]);
}(_vuePropertyDecorator.Vue);
OrderModal = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    ProductOrderForm: _ExportProductOrderForm.default,
    ExportWarehousePrint: _ExportWarehousePrint.default,
    ExportPrintInformationForm: _ExportPrintInformationForm.default,
    ExportWarehousePrintPaymentRequest: _ExportWarehousePrintPaymentRequest.default,
    SelectSingleDateModal: _SelectSingleDateModal.default
  }
})], OrderModal);
var _default = exports.default = OrderModal;